import { Line, ReelWinPosition } from '@cgs/data-access';
import { BuildAction } from '@cgs/shared';
import { Container, EmptyAction, IntervalAction, ParallelAction, SequenceAction } from '@cgs/wge';
import { SpinConfig } from '../../../../reels_engine/game_config/game_config';
import { T_ILogoAnimationProvider } from '../../../../type_definitions';
import { SLOT_SESSION_TOKEN, SlotSession } from '../../../common/slot_session';
import { ILogoAnimationProvider } from '../../i_logo_animation_provider';
import { AllWinLinesAction } from './all_win_lines_action';
import { IWinLinesAction } from './i_win_lines_action';

export class ShortNWaysLinesAction extends BuildAction implements IWinLinesAction {
  protected _winPositions: ReelWinPosition[];
  protected _action: IntervalAction;
  protected _container: Container;
  private readonly _winLines: Line[] = [];
  private readonly _spinConfig: SpinConfig;
  private readonly _animName: string;
  private readonly _logoAnimationProvider: ILogoAnimationProvider | null;
  private readonly _slotSession: SlotSession;

  constructor(
    container: Container,
    winLines: Line[],
    winPositions: ReelWinPosition[],
    spinConfig: SpinConfig,
    animName: string = 'anim'
  ) {
    super();
    this._container = container;
    this._winLines = winLines;
    this._winPositions = winPositions;
    this._spinConfig = spinConfig;
    this._animName = animName;
    this._logoAnimationProvider = this._container.resolve<ILogoAnimationProvider>(
      T_ILogoAnimationProvider,
      { optional: true }
    );
    this._slotSession = container.resolve<SlotSession>(SLOT_SESSION_TOKEN);
    this._action = this.CreateAction(this._container, this._winLines);
    this.withDuration(this._action.duration);
  }

  get container(): Container {
    return this._container;
  }

  set container(value: Container) {
    this._container = value;
  }

  get winLines(): Line[] {
    return this._winLines;
  }

  get winPositions(): ReelWinPosition[] {
    return this._winPositions;
  }

  get animName(): string {
    return this._animName;
  }

  get slotSession(): SlotSession {
    return this._slotSession;
  }

  buildAction(): IntervalAction {
    return this._action;
  }

  private CreateAction(container: Container, _winLines: Line[]): IntervalAction {
    const sortedWinLines = this.getSortedWinLinesWithWinPositions();

    if (!sortedWinLines.length) {
      return new EmptyAction().withDuration(this._spinConfig.noWinDelay);
    }

    return new SequenceAction([
      new ParallelAction([
        new AllWinLinesAction(container, sortedWinLines),
        this._logoAnimationProvider
          ? this._logoAnimationProvider.getShortWinLineAction()
          : new EmptyAction(),
      ]),
      new EmptyAction().withDuration(0.2),
    ]);
  }

  public getSortedWinLinesWithWinPositions(): Line[] {
    const winLines = this._winLines.map((winLine) => {
      const modifiedWinLine = { ...winLine };
      modifiedWinLine.winAmount =
        winLine.winAmount * (winLine.multiplier ?? 1) * this._slotSession.currentBet.bet;

      return modifiedWinLine;
    });

    if (this._winPositions?.length > 0) {
      for (const winPos of this._winPositions) {
        const newWinLine = new Line();
        newWinLine.positions = winPos.positions;
        newWinLine.symbolId = winPos.symbolId;
        newWinLine.winAmount = winPos.win;
        winLines.push(newWinLine);
      }
    }
    winLines.sort((a, b) => {
      const win = b.winAmount - a.winAmount;
      if (win === 0) {
        // TODO: symbolId может быть равен null?
        return a.symbolId! - b.symbolId!;
      }
      return win;
    });
    return winLines;
  }
}
